import { CR_SUBMISSION } from '../../../constants';

export type SetStarRatingTitleInvalidParams = {
    rootElement: Pick<HTMLElement, 'querySelector'>;
};
export const setStarRatingTitleInvalid = ({ rootElement }: SetStarRatingTitleInvalidParams) => {
    const starRatingTitle = rootElement.querySelector<HTMLSpanElement>(CR_SUBMISSION.STAR_RATING.TITLE_SELECTOR);
    if (starRatingTitle === null) return;
    starRatingTitle.classList.add(CR_SUBMISSION.STAR_RATING.TITLE_INVALID_CLASS);
};
